import { DateTime } from 'luxon';
import { RequiredFields } from '../../../util/util';

export type StatusTransitionRequirementRow = {
  id: string;
  fromStatus: string;
  toStatus: string;
  stepId: string;
  entity: TransitionableEntity;
  createdAt: DateTime;
  createdBy: number;
};

export type StatusTransitionRequirement = {
  id: string;
  fromStatus: string;
  toStatus: string;
  step: Step;
  entity: TransitionableEntity;
  createdAt: DateTime;
  createdBy: number;
};

export type StepAssociation = {
  entity: TransitionableEntity;
  fromStatuses: string[];
};
export type Step = {
  id: string;
  name: string;
  label: string;
  metadata: { associated: StepAssociation[] };
};

export type StatusTransitionRequirementRequest = {
  fromStatus: string;
  toStatus: string;
  stepId: string;
  entity: TransitionableEntity;
};

export type StatusTransitionRequirementSearchRequest = RequiredFields<
  Partial<StatusTransitionRequirementRequest>,
  'entity'
>;

export enum TransitionableEntity {
  ORDER = 'ORDER',
  ORDER_PRODUCT = 'ORDER_PRODUCT',
  DISPATCH = 'DISPATCH',
}
